import { render, staticRenderFns } from "./qycx.vue?vue&type=template&id=a5195998&scoped=true&"
import script from "./qycx.vue?vue&type=script&lang=js&"
export * from "./qycx.vue?vue&type=script&lang=js&"
import style0 from "./qycx.vue?vue&type=style&index=0&id=a5195998&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5195998",
  null
  
)

export default component.exports